import { getColumnsForType } from "./columns.js";

function getHeaderAlignClass(type, columnId) {
  if (type === "creator") return columnId === "name" ? "text-left" : "text-center";
  return columnId === "name" || columnId === "author" ? "text-left" : "text-center";
}

function getNoResultsAlignClass(type, columnId) {
  if (type === "creator") return columnId === "name" ? "text-left" : "text-center";
  if (columnId === "name" || columnId === "author") return "text-left";
  return "text-center";
}

function renderSortArrowsHtml() {
  return `<span class="sort-arrows-container"><span class="sort-arrow sort-arrow-up"><svg width="7" height="5" viewBox="0 0 8 6" fill="currentColor"><path d="M4 0 L8 6 L0 6 Z" /></svg></span><span class="sort-arrow sort-arrow-down"><svg width="7" height="5" viewBox="0 0 8 6" fill="currentColor"><path d="M4 0 L8 6 L0 6 Z" /></svg></span></span>`;
}

function renderTopTooltip(contentHtml, tooltipText) {
  return `<div class="with-tooltip">${contentHtml}<div class="tooltip top"><div class="tooltip-item">${tooltipText}</div></div></div>`;
}

function renderHeaderCell(type, column) {
  const sortableClass = column.sortable ? "sortable cursor-pointer" : "";
  const dataColumn = column.sortable ? ` data-column="${column.id}"` : "";
  const labelHtml =
    column.labelHtml || (column.sortable ? `<span class="sortable-header">${column.label || ""}</span>` : (column.label || ""));
  const arrowsHtml = column.sortable ? ` ${renderSortArrowsHtml()}` : "";
  return `<th class="${sortableClass} h-auto py-4 ${getHeaderAlignClass(type, column.id)} ${column.headerClass}"${dataColumn}>${labelHtml}${arrowsHtml}</th>`;
}

function renderStandardFooterCell(column) {
  if (column.id === "rank") {
    const content = '<div class="tfoot-rank-total">-</div><div class="tfoot-rank-breakdown">- / -</div>';
    return `<td class="${column.footerClass} text-center" id="tfoot-rank">${renderTopTooltip(content, "Items total<br/>free / paid")}</td>`;
  }
  if (column.id === "change") {
    const content =
      '<div class="tfoot-change-events"><span class="tfoot-change-new">-</span> <span class="tfoot-change-sep">/</span> <span class="tfoot-change-movedin">-</span> <span class="tfoot-change-sep">/</span> <span class="tfoot-change-comeback">-</span> <span class="tfoot-change-sep">/</span> <span class="tfoot-change-price">-</span></div>';
    return `<td class="${column.footerClass} text-center" id="tfoot-change">${renderTopTooltip(content, "Label counters<br/>new / moved-in / comeback / repriced")}</td>`;
  }
  if (column.id === "trend") return `<td class="${column.footerClass} text-center">-</td>`;
  if (column.id === "price") {
    const content = '<div class="tfoot-price-label">avg / mid</div><div class="tfoot-price-values">- / -</div>';
    return `<td class="${column.footerClass} text-center" id="tfoot-price">${renderTopTooltip(content, "Average price vs median price")}</td>`;
  }
  if (column.id === "image") return `<td class="${column.footerClass}"></td>`;
  if (column.id === "name") return `<td class="${column.footerClass} text-left" id="tfoot-name">-</td>`;
  if (column.id === "medals") return `<td class="${column.footerClass} text-center" id="tfoot-medals"></td>`;
  if (column.id === "author") return `<td class="${column.footerClass} text-left" id="tfoot-author">-</td>`;
  return `<td class="${column.footerClass}">-</td>`;
}

function renderCreatorFooterCell(column) {
  if (column.id === "name") {
    return `<td class="text-left creators-col-name ${column.footerClass}" id="tfoot-creators-count">-</td>`;
  }
  if (column.id === "templates") {
    return `<td class="text-center creators-col-metric ${column.footerClass}" id="tfoot-creators-templates">-</td>`;
  }
  if (column.id === "templatesdelta") {
    return `<td class="text-center creators-col-delta ${column.footerClass}" id="tfoot-creators-templatesdelta">-</td>`;
  }
  if (column.id === "components") {
    return `<td class="text-center creators-col-metric ${column.footerClass}" id="tfoot-creators-components">-</td>`;
  }
  if (column.id === "componentsdelta") {
    return `<td class="text-center creators-col-delta ${column.footerClass}" id="tfoot-creators-componentsdelta">-</td>`;
  }
  if (column.id === "total") {
    return `<td class="text-center creators-col-metric ${column.footerClass}" id="tfoot-creators-total">-</td>`;
  }
  if (column.id === "totaldelta") {
    return `<td class="text-center creators-col-delta ${column.footerClass}" id="tfoot-creators-totaldelta">-</td>`;
  }
  const isDelta = column.id === "templatesdelta" || column.id === "componentsdelta" || column.id === "totaldelta";
  return `<td class="${isDelta ? "creators-col-delta" : "creators-col-metric"} ${column.footerClass}"></td>`;
}

function renderNoResultsCell(type, column, message) {
  const align = getNoResultsAlignClass(type, column.id);
  if (column.id === "name") {
    return `<td class="${column.cellClass} ${align} ranks-no-results-message">${message}</td>`;
  }
  if (column.id === "image" || column.id === "medals") {
    return `<td class="${column.cellClass} ${align}"></td>`;
  }
  return `<td class="${column.cellClass} ${align}">-</td>`;
}

export function buildNoResultsRow(type, message = "No results found") {
  const normalizedType = type === "creator" ? "creator" : "template";
  const columns = getColumnsForType(normalizedType);
  const cells = columns.map((column) => renderNoResultsCell(normalizedType, column, message)).join("");
  return `<tr class="clusterize-no-data ranks-no-results">${cells}</tr>`;
}

export function buildTableStructureHtml() {
  const standardColumns = getColumnsForType("template");
  const creatorColumns = getColumnsForType("creator");

  const standardHeaderHtml = standardColumns.map((column) => renderHeaderCell("template", column)).join("");
  const creatorHeaderHtml = creatorColumns.map((column) => renderHeaderCell("creator", column)).join("");
  const standardFooterHtml = standardColumns.map((column) => renderStandardFooterCell(column)).join("");
  const creatorFooterHtml = creatorColumns.map((column) => renderCreatorFooterCell(column)).join("");

  return {
    thead: `<tr id="standard-thead-row" class="standard-head">${standardHeaderHtml}</tr><tr id="creators-thead-row" class="creators-head">${creatorHeaderHtml}</tr>`,
    tfoot: `<tr id="standard-tfoot-row" class="standard-foot">${standardFooterHtml}</tr><tr id="creators-tfoot-row" class="creators-foot">${creatorFooterHtml}</tr>`,
  };
}

export function mountTableStructure({ thead, tfoot }) {
  if (!thead || !tfoot) return;
  const structure = buildTableStructureHtml();
  thead.innerHTML = structure.thead;
  tfoot.innerHTML = structure.tfoot;
}
